import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["content"]

  connect() {
    // Optional: Log a message to verify the controller is connected
    console.log("Hello, Dropdown!");
    alert("Hello, Dropdown!"); // Alert to confirm the controller is working
  }

  toggle() {
    this.contentTarget.classList.toggle("hidden") // Toggle the "hidden" class
  }

  // Optional: Close the dropdown when clicking outside
  hide(event) {
    if (!this.element.contains(event.target)) {
      this.contentTarget.classList.add("hidden")
    }
  }

}
